<template>
  <div v-if="data">
    <div class="container">
      <div class="clearfix"></div>
      <br />
      <!-- About this app -->
      <div class="row" v-if="page === 'aboutapp'">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <h4 class="text-info" v-html="data.faq.topHeaderAbout"></h4>
          <br />
          <p v-html="data.faq.aboutText"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- Contact -->
      <div class="row" v-if="page === 'contact'">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <h4 class="text-info" v-html="data.faq.topHeaderContact"></h4>
          <br />
          <p v-html="data.faq.contactText"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- Cookies -->
      <div class="row" v-if="page === 'cookies'">
        <div class="col-sm"></div>
        <div class="col-md-4">
          <h4 class="text-info" v-html="data.faq.cookiesHeader"></h4>
          <br />
          <p v-html="data.faq.cookiesText"></p>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'faq',
  props: ['page'],
  components: {},
  data () {
    return {
      data: null
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          faq(locale: ` + sessionStorage.getItem('language') + `) {
            topHeaderAbout
            topHeaderContact
            cookiesHeader
            cookiesText
            contactText
            aboutText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding-bottom: 3vh;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 8vh;
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue